import { isBefore, isAfter } from 'date-fns';
import { useReducer, useCallback } from 'react';

const populateDatesWithTimes = (dateRange, dateRangeLimits) => {
    let { start, end } = dateRange;
    const { min, max } = dateRangeLimits;
    if (start) {
        if ((start === null || start === void 0 ? void 0 : start.toDateString()) === (min === null || min === void 0 ? void 0 : min.toDateString())) {
            // If user selected minimal date for start of interval - we should take time from `min` object
            start = min;
        }
    }
    if (end) {
        if ((end === null || end === void 0 ? void 0 : end.toDateString()) === (max === null || max === void 0 ? void 0 : max.toDateString())) {
            // If user selected maximum date for end of interval - we should take time from `max` object
            end = max;
        }
        else {
            // Otherwise - day should end at 23:59:59:999
            end = new Date(end.setHours(23, 59, 59, 999));
        }
    }
    return { start, end };
};
// @ts-ignore
function reducer(state, action) {
    switch (action.type) {
        case 'end': {
            const end = action.payload;
            if (state.start && isBefore(end, state.start)) {
                return { end };
            }
            return { ...state, end };
        }
        case 'start': {
            const start = action.payload;
            if (state.end && isAfter(start, state.end)) {
                return { start };
            }
            return { ...state, start };
        }
        case 'select':
            if (state.end || (!state.end && !state.start)) {
                // If there is no timeRange selected or both ends selected - we should start selecting new timeRange. So treating selected date as a start
                return populateDatesWithTimes({ start: action.payload }, { min: action.min, max: action.max });
            }
            if (state.start) {
                if (isBefore(action.payload, state.start)) {
                    // If second click is the date that is before whatever user selected for his first click - we should swap start and end
                    return populateDatesWithTimes({
                        end: state.start,
                        start: action.payload
                    }, { min: action.min, max: action.max });
                }
                return populateDatesWithTimes({
                    ...state,
                    end: action.payload
                }, { min: action.min, max: action.max });
            }
    }
}
function useDateRangeState(initialState = {}, min, max) {
    const [dateRange, dispatch] = useReducer(reducer, initialState);
    const setEndDate = useCallback((endDate) => {
        dispatch({ type: 'end', payload: endDate, min, max });
    }, []);
    const setStartDate = useCallback((startDate) => {
        dispatch({ type: 'start', payload: startDate, min, max });
    }, []);
    const selectDate = useCallback((selectedDate) => {
        dispatch({ type: 'select', payload: selectedDate, min, max });
    }, []);
    return { selectDate, setEndDate, setStartDate, dateRange };
}

export { useDateRangeState };
//# sourceMappingURL=useDateRangeState.esm.js.map
